import React from "react";
import Table from "../../../../../../common/element/Table";
import moment from "moment/moment";
const { Tr, Th, Td, THead, TBody } = Table;
const ClientOverviewList = ({
  tableData,
  handleFilterSort,
  filtersort,
  filterorder,
}) => {
  return (
    <React.Fragment>
      <div className="overflow-hidden border rounded-lg border-gray-200">
        <Table>
          <THead>
            <Tr>
              <Th>
                <span className="flex items-center gap-1">Client name</span>
              </Th>
              <Th>ABN/NZBN</Th>
              <Th>Lifetime value</Th>
              <Th>Status</Th>
              <Th onClick={(e) => handleFilterSort(e, "provider_count")}>
                <span className="flex items-center gap-1">
                  Providers no.
                  <svg
                    className={`transform ${
                      filtersort === "provider_count" && filterorder === "asc"
                        ? "rotate-180"
                        : ""
                    }`}
                    width="17"
                    height="16"
                    viewBox="0 0 17 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M8.712 3.333v9.334m0 0L13.38 8m-4.667 4.667L4.045 8"
                      stroke="#475467"
                      stroke-width="1.333"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </span>
              </Th>
              <Th onClick={(e) => handleFilterSort(e, "created_date")}>
                <span className="flex items-center gap-1">
                  Date joined
                  <svg
                    className={`transform ${
                      filtersort === "created_date" && filterorder === "asc"
                        ? "rotate-180"
                        : ""
                    }`}
                    width="17"
                    height="16"
                    viewBox="0 0 17 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M8.712 3.333v9.334m0 0L13.38 8m-4.667 4.667L4.045 8"
                      stroke="#475467"
                      stroke-width="1.333"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </span>
              </Th>
              <Th onClick={(e) => handleFilterSort(e, "renewal_date")}>
                <span className="flex items-center gap-1">
                  Renewal date
                  <svg
                    className={`transform ${
                      filtersort === "renewal_date" && filterorder === "asc"
                        ? "rotate-180"
                        : ""
                    }`}
                    width="17"
                    height="16"
                    viewBox="0 0 17 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M8.712 3.333v9.334m0 0L13.38 8m-4.667 4.667L4.045 8"
                      stroke="#475467"
                      stroke-width="1.333"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </span>
              </Th>
            </Tr>
          </THead>
          <TBody>
            {tableData?.length > 0 &&
              tableData?.map((item, index) => {
                return (
                  <Tr key={index}>
                    <Td>{item?.trading_name}</Td>
                    <Td>{item?.abn_nzbn}</Td>
                    <Td>{item?.life_time_value ? `$${item.life_time_value}` : '-'}</Td>
                    <Td>{item?.status}</Td>
                    <Td>{item?.provider_count}</Td>
                    <Td>{moment(item?.date_joined).format("DD/MM/YYYY")}</Td>
                    <Td>{moment(item?.renewal_date).format("DD/MM/YYYY")}</Td>
                  </Tr>
                );
              })}
        
          </TBody>
        </Table>
      </div>
    </React.Fragment>
  );
};
export default ClientOverviewList;
